import { envToConfig } from '@/env'
import { Config } from '@/libs/config/types'

/**
 * Returns the application config, built from the `VITE_*` env vars that were
 * validated at build time by `parseEnv`.
 */
export function getAppConfig(): Config {
  return envToConfig()
}

/**
 *
 */
export function isNonProdEnv(): boolean {
  return getAppConfig().env !== 'prod'
}

/**
 * Determines whether this is a local environment (dev or test).
 */
export function isLocalEnv(): boolean {
  return getAppConfig().env === 'dev'
}
